import { getDecimalValue } from './decimalWrapper';
/**
 * Calculates the domain for a chart based on the minimum and maximum values.
 * @param min The minimum value for the chart domain.
 * @param max The maximum value for the chart domain.
 * returns An array containing the minimum and maximum values for the chart domain.
 */
export const getChartDomain = (min, max) => {
    const range = getDecimalValue(max).minus(min);
    const rawTickInterval = range.div(4);
    const exponent = rawTickInterval.logarithm().floor();
    const magnitude = getDecimalValue(10).pow(exponent);
    const residual = rawTickInterval.div(magnitude);
    let tickInterval;
    if (residual.lessThan(1.5)) {
        tickInterval = magnitude;
    }
    else if (residual.lessThan(3.5)) {
        tickInterval = magnitude.times(2);
    }
    else if (residual.lessThan(7.5)) {
        tickInterval = magnitude.times(5);
    }
    else {
        tickInterval = magnitude.times(10);
    }
    const minimumNumberOfChart = getDecimalValue(min)
        .div(tickInterval)
        .floor()
        .times(tickInterval);
    const maximumNumberOfChart = getDecimalValue(max)
        .div(tickInterval)
        .ceil()
        .times(tickInterval);
    return [minimumNumberOfChart.toNumber(), maximumNumberOfChart.toNumber()];
};
export const getChartInterval = (dataLength, intervalNumber = 5) => {
    if (typeof dataLength !== 'number')
        return 1;
    const decimalDataLength = getDecimalValue(dataLength);
    const decimalIntervalNumber = getDecimalValue(intervalNumber);
    const remainder = decimalDataLength.mod(decimalIntervalNumber);
    if (remainder.equals(0)) {
        return decimalDataLength.div(decimalIntervalNumber).toNumber();
    }
    else {
        return decimalDataLength.div(decimalIntervalNumber).round().toNumber();
    }
};
export const getChartOffset = (defaultValue, min, max) => {
    if (min === max) {
        return '100%';
    }
    const minDecimal = getDecimalValue(min);
    const maxDecimal = getDecimalValue(max);
    const defaultDecimal = getDecimalValue(defaultValue);
    const minMaxDifference = maxDecimal.minus(minDecimal);
    const maxDefaultDifference = maxDecimal.minus(defaultDecimal);
    const diffInPercentage = maxDefaultDifference.div(minMaxDifference);
    return diffInPercentage.times(100).toString() + '%';
};
//# sourceMappingURL=chart.js.map